import { AuthUser } from 'aws-amplify/auth';
import { create } from 'zustand';

const initialState = {
    user: undefined,
    isUserSet: false,
    isAdmin: false,
    userGroups: [],
    userScopes: [],
    userInstanceIds: [],
    userCustomerIds: [],
    userLocationIds: [],
    userPracticeIds: [],
    userMapPractitionerId: '',
    pictureUrl: undefined,
    userEmail: '',
};

export const useAuthStore = create<{
    user: AuthUser | undefined;
    isUserSet: boolean;
    isAdmin: boolean;
    userGroups: string[];
    userScopes: string[];
    userInstanceIds: string[];
    userCustomerIds: string[];
    userLocationIds: string[];
    userPracticeIds: string[];
    userMapPractitionerId: string;
    pictureUrl?: string;
    userEmail: string;
    reset: () => void;
}>((set) => ({
    ...initialState,
    // setting is_user_set to true to show login page
    reset: (): void => set({ ...initialState, isUserSet: true }),
}));
